import { Component } from '@angular/core';
import {config} from "./config/config_gangabet";
import { ApiRestService } from './services/api-rest.service';
import {TranslateService} from '@ngx-translate/core';
declare var $: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'my-app';
  config = config;
  language : string;
  urlGeoApi: string;
  partner:string;
  loadView: boolean = false;
  country : string;

  langObj2={
    "pe":{
      "es":{},
      "en":{},
      "pt":{}
    },
    "mx":{
      "es":{},
      "en":{},
      "pt":{},
      "hn":{}
    },
    "br":{
      "es":{},
      "pt":{}
    }
  };

  constructor(
    private apiRestService: ApiRestService,
    private translate: TranslateService
    ) {


    this.country = this.config.countryFixed;
    this.language = this.config.langDefault;

  }

	ngOnInit() {
    var vthis = this;
    this.urlGeoApi = 'https://partnerapi.virtualsoft.tech/Lobby/Api/GeoApi/GeoApi2';

    this.apiRestService.requestCustom(this.urlGeoApi , {partner: this.partner}).subscribe((response2: any) => {
      console.log(response2.countryCode.toLowerCase());
      if(response2 != undefined && response2.countryCode != undefined && response2.countryCode != '') {
          this.country = response2.countryCode.toLowerCase();
          this.loadView = true;
        }
      });

    this.translate.use(this.language);
    this.apiRestService.setPartner(this.config.partner);
    var vthis = this;
    if ($('.scroll-to-target').length) {
        $(".scroll-to-target").on('click', function () {
            var target = $(this).attr('data-target');
            // animate
            $('html, body').animate({
                scrollTop: $(target).offset().top
            }, 1000);

            return false;

        });
    }
		  const link: any = document.querySelector(`link[rel*='icon']`) || document.createElement('link');
		  link.type = 'image/x-icon';
		  link.rel = 'shortcut icon';
		  link.href = this.config.favicon || 'base64';
		  document.getElementsByTagName('head')[ 0 ].appendChild(link)

       	$(document).ready(function() {

       });

      this.translate.setTranslation(this.language,vthis.langObj2[this.country][this.language],true);

    }
}
